import React, { useEffect } from 'react';
import Card from "@scentregroup/ui/components/card";
import CallToAction from "@scentregroup/ui/components/call-to-action";
import Paragraph from "@scentregroup/ui/components/paragraph";
import Row from "@scentregroup/ui/components/form/row";
import { getCountry } from '../../helpers/get-country';
import { titleFromContentPage } from '../../helpers/title-from-content-page';
import Modules from '../../components/modules';
import ExternalLink from '../../components/external-link';
import PageLanding from '../../components/page-landing';
import Article from '../../components/article';
import withContentPage from '../../containers/with-content-page';
import { isPromotionFeature, ContentPageDisplayModes, isDisplayMode } from '../../../types/content-page';
import pagesHoc from '../pages-hoc';
import analyticsUtils from '../../helpers/analytics-utils';
import { createProductClickEvent } from '../../helpers/analytics-utils/productClick';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getProductDetailEvent = modules => {
  analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.PRODUCT_IMPRESSION,
    ecommerce: {
      currencyCode: 'AUD',
      impressions: modules ? modules.entries.map((item, index) => ({
        name: item.productName,
        id: "card100".concat(index + 1),
        category: item.productName,
        brand: 'westfield',
        position: index + 1,
        list: item.productName
      })) : []
    }
  });
};
const PromotionalPage = _ref => {
  let {
    modules,
    metaData
  } = _ref;
  const comparisonModule = modules && modules.find(_ref2 => {
    let {
      displayMode
    } = _ref2;
    return isDisplayMode(displayMode, ContentPageDisplayModes.COMPARISON_ITEM);
  });
  useEffect(() => {
    if (comparisonModule) {
      getProductDetailEvent(comparisonModule);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const firstModule = modules && Boolean(modules === null || modules === void 0 ? void 0 : modules.length) && isPromotionFeature(modules[0]) && modules[0];
  const restModules = modules && firstModule ? modules.slice(1) : modules;
  const dgcComparisonItem = comparisonModule && comparisonModule.entries.find(_ref3 => {
    let {
      productName
    } = _ref3;
    return productName === analyticsUtils.categories.DIGITAL_GIFT_CARD;
  });
  return /*#__PURE__*/_jsx("div", {
    className: style.evolved,
    "data-id": "promotional-page_index_PromotionalPage_div",
    children: modules && /*#__PURE__*/_jsxs(_Fragment, {
      children: [firstModule && /*#__PURE__*/_jsx(PageLanding, {
        desktopImage: {
          src: firstModule.desktopImageUrl
        },
        mobileImage: {
          src: firstModule.mobileImageUrl
        },
        logo: undefined,
        heading: undefined,
        dataTestId: undefined,
        "data-id": "promotional-page_index_PromotionalPage_PageLanding",
        children: /*#__PURE__*/_jsx(Card, {
          className: style.card,
          "data-id": "promotional-page_index_PromotionalPage_PageLanding_Card",
          children: /*#__PURE__*/_jsxs(Article, {
            heading: firstModule.title,
            "data-id": "promotional-page_index_PromotionalPage_Card_Article",
            children: [/*#__PURE__*/_jsx(Paragraph, {
              "data-id": "promotional-page_index_PromotionalPage_Article_Paragraph",
              children: firstModule.body
            }), /*#__PURE__*/_jsxs(Row, {
              className: style.callToActionWrapper,
              "data-id": "promotional-page_index_PromotionalPage_Article_Row",
              children: [/*#__PURE__*/_jsx(CallToAction, {
                rel: 'noopener',
                target: '_self',
                inverted: true,
                inferior: true,
                url: firstModule.callToAction.address,
                element: ExternalLink,
                eventCategory: metaData ? metaData.title : undefined,
                eventAction: analyticsUtils.categories.FEATURE_CTA,
                eventLabel: firstModule.callToAction.category,
                "data-id": "promotional-page_index_PromotionalPage_Row_CallToAction",
                children: firstModule.callToAction.category
              }), dgcComparisonItem ? /*#__PURE__*/_jsx(CallToAction, {
                rel: 'noopener',
                target: '_self',
                url: dgcComparisonItem.callToAction.url,
                element: ExternalLink,
                onClick: () => createProductClickEvent(dgcComparisonItem.productName, analyticsUtils.categories.FEATURE_CTA),
                "data-id": "promotional-page_index_PromotionalPage_CallToAction_7",
                children: dgcComparisonItem.callToAction.category
              }) : /*#__PURE__*/_jsx("div", {
                "data-id": "promotional-page_index_PromotionalPage_div"
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Modules, {
        modules: restModules,
        className: style.initialContentGroup,
        initialAngle: "top-right",
        centreTitle: undefined,
        "data-id": "promotional-page_index_PromotionalPage_Modules"
      })]
    })
  });
};
const getMetaData = _ref4 => {
  let {
    metaData,
    staticContext
  } = _ref4;
  const COUNTRY = getCountry(staticContext);
  return {
    title: titleFromContentPage(COUNTRY, metaData),
    description: metaData === null || metaData === void 0 ? void 0 : metaData.shortDescription
  };
};
export default withContentPage(pagesHoc(PromotionalPage, getMetaData));